import { ApolloClient } from '@apollo/client'
import { actionTypes } from './index'
import createFetchSaga from '@utils/store/createFetchSaga'
import suppliersGetQuery from '@queries/suppliersGetQuery'
import { sagaDebounce } from '@store/helpers'

const fetchList = async (client: ApolloClient<any>, action: Action): Promise<any> => {
  const suppliers = await client
    .query({ query: suppliersGetQuery, variables: action.payload })
    .then(({ data }) => ({ data: data?.suppliersGet }))

  return suppliers
}

export default function* watch(): Generator {
  if (typeof window === 'undefined') return
  yield sagaDebounce(200, actionTypes.run, createFetchSaga(actionTypes.run, fetchList))
}
